// extracted by mini-css-extract-plugin
export var fadeIn = "_81-0";